import { SHOP } from '@hive/status'

export const SHOP_STATUS_LABELS = [
  {
    label: 'Включён',
    value: SHOP.ENABLED
  },
  {
    label: 'Отключён',
    value: SHOP.DISABLED
  },
  {
    label: 'Архивирован',
    value: SHOP.ARCHIVED
  }
]

export interface ShopExpressStatusLabel {
  label: string
  value: number
}

export const SHOP_EXPRESS_STATUS_LABELS: ShopExpressStatusLabel[] = [
  {
    label: 'Включена',
    value: 1
  },
  {
    label: 'Отключена',
    value: 0
  }
]


export const UPLOAD_NAME_SHOP_IMAGE= 'shop-image'
export const UPLOAD_NAME_SHOP_TAG_ICON = 'shop-tag-icon'